import { gql } from "@apollo/client";

export const ADD_FRANCHISE_DEPOSITE = gql`
mutation AddFranchiseDeposit($franchiseId: ID!, $amount: Float!, $transactionId: String!, $photo: String) {
  addFranchiseDeposit(franchiseId: $franchiseId, amount: $amount, transactionId: $transactionId, photo: $photo) {
    id
  }
}
`